import styles from "../../styles/AboutUs/MeetTheTeam.module.css";

const Member = ({ data }) => {
  return (
    <div className={styles.memberContainer}>
      <div className={styles.memberImage}>
        <img src={data?.src ? data.src : "/nophoto.jpg"} className={styles.memberImage} alt="profile-photo" />
      </div>
      <div>
        <div className={styles.memberName}>{data?.name || "Member Name"}</div>
        <div className={styles.memberPostion}>{data?.position || "Member Position"}</div>
        <div className={styles.memberDesc}>{data?.desc}</div>
      </div>
    </div>
  );
};

export default Member;
